










































import { Component, Vue, Prop, Model } from 'vue-property-decorator';

import InputWrapper from '@/componentsV2/molecules/Inputs/InputWrapper.vue';
import colorsDictionary from '@/componentsV2/molecules/ColorPicker/colorsDictionary';
import { upperCaseFirstLetter } from '@/utils/string';

@Component<ColorPicker>({
  components: {
    InputWrapper
  }
})
export default class ColorPicker extends Vue {
  @Model('input') value!: string;

  @Prop() name!: string;
  @Prop({ default: 'Pick a color' }) label?: string;
  @Prop({ default: false }) hasError?: boolean;
  @Prop({ default: false }) disabled?: boolean;
  @Prop({ default: false }) justBoldColors?: boolean;
  @Prop({ default: false }) showColorName?: boolean;
  @Prop({ default: '' }) helpText?: string;

  colorsDictionary = colorsDictionary;
  upperCaseFirstLetter = upperCaseFirstLetter;

  get helpErrId() {
    return `err-${this.name}`;
  }

  filterGroup(groupColor: Record<string, string>) {
    if (!this.justBoldColors) return groupColor;

    Object.keys(groupColor).forEach(colorName => {
      if (colorName.includes('-600') || colorName.includes('-800'))
        delete groupColor[colorName];
    });
    return groupColor;
  }
}
